import {
  Card,
  Text,
  Group,
  Button,
  ThemeIcon,
  Badge,
  Flex,
  Modal,
  Stack,
} from "@mantine/core";
import { SiGooglecalendar } from "react-icons/si";
import { useDisclosure } from "@mantine/hooks";
import useGoogleCalendar from "hooks/useGoogleCalendar";

const GoogleCalendarCard = () => {
  const [confirmModalOpened, { open, close }] = useDisclosure(false);
  const { isConnected, connect, disconnect, loading } = useGoogleCalendar();

  const handleDisconnect = async () => {
    const result = await disconnect();
    if (result.success) {
      close();
    }
  };

  const handleButtonClick = async () => {
    if (isConnected) {
      open();
    } else {
      await connect(`${window.location.pathname}${window.location.search}`);
    }
  };

  return (
    <>
      <Card withBorder shadow="sm" radius="md" padding="lg">
        <Flex justify="space-between" align="center" gap="md">
          <Flex gap="md" align="center">
            <ThemeIcon
              size={48}
              radius="md"
              variant="light"
              style={{
                backgroundColor: "#4285F415",
                color: "#4285F4",
                minWidth: "48px",
              }}
            >
              <SiGooglecalendar size={24} />
            </ThemeIcon>

            <div>
              <Group spacing="xs" mb={4}>
                <Text fw={600} size="lg" style={{ lineHeight: 1 }}>
                  Google Calendar
                </Text>
                <Badge size="xs" variant="filled" color="blue" radius="sm">
                  Recommended
                </Badge>
              </Group>
              <Text size="sm" color="dimmed" style={{ lineHeight: 1.4 }}>
                Sync your schedule and manage events directly from your Google
                Calendar.
              </Text>
            </div>
          </Flex>

          <Button
            variant={isConnected ? "outline" : "filled"}
            color={isConnected ? "red" : "blue"}
            onClick={handleButtonClick}
            radius="md"
            size="sm"
            style={{ minWidth: "120px" }}
            loading={loading}
          >
            {isConnected ? "Disconnect" : "Connect"}
          </Button>
        </Flex>
      </Card>

      <Modal
        opened={confirmModalOpened}
        onClose={close}
        title="Disconnect Google Calendar"
        centered
      >
        <Stack>
          <Text size="sm">
            Are you sure you want to disconnect your Google Calendar? You will
            need to reconnect to sync your events again.
          </Text>
          <Group position="right" mt="md">
            <Button variant="default" onClick={close} disabled={loading}>
              Cancel
            </Button>
            <Button color="red" onClick={handleDisconnect} loading={loading}>
              Disconnect
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default GoogleCalendarCard;
